const LargeWeekViewVerticalLines = () => {
    return(
        <div className="col-start-1 col-end-2 row-start-1 hidden grid-cols-7 grid-rows-1 divide-x divide-gray-300 sm:grid sm:grid-cols-7">
          <div className="col-start-1 border-solid border-0 row-span-full" />
          <div className="col-start-2 border-solid border-0 row-span-full" />
          <div className="col-start-3 border-solid border-0 row-span-full" />
          <div className="col-start-4 border-solid border-0 row-span-full" />
          <div className="col-start-5 border-solid border-0 row-span-full" />
          <div className="col-start-6 border-solid border-0 row-span-full" />
          <div className="col-start-7 border-solid border-0 row-span-full" />
          <div className="col-start-8 border-solid border-0 row-span-full" />
        </div>
    )
}
export default LargeWeekViewVerticalLines